const content = {
  de: {
    header: {
      homepage: 'https://karaca.ovh',
      title: 'MK.',
    },
    about: {
      greeting: 'Hallo, ich bin Mehmet Karaca',
      name: 'Mehmet Karaca',
      role: 'Data Scientist & AI Spezialist',
      description: `Master-Student in Data Science mit fundierter Berufserfahrung in Business Informatics und KI. Ich entwickle intelligente Lösungen an der Schnittstelle von Machine Learning, Computer Vision und Smart Factory – von der Halbleiterproduktion bis zur nachhaltigen Produktentwicklung. Aktuell studiere ich an der NOVA IMS in Lissabon und bringe praktische Erfahrung aus der Industrie mit Forschung zusammen.`,
      resume: '/Karaca_Mehmet_CV_1.pdf',
      social: {
        linkedin: 'https://linkedin.com/in/karaca-mehmet',
        github: 'https://github.com/mehmet1700',
      },
    },
    projects: [
      {
        name: 'Synthetische Marktforschungsdaten mit LLMs',
        description:
          'Entwicklung einer Zwei-LLM-Architektur zur Generierung diverser Kundenpersonas und deren Präferenzen. Training eines CTGAN-Modells auf synthetischen Daten für realistische Marktforschungsdatensätze. Präsentiert auf der EU4Dual Konferenz in Spanien/Frankreich.',
        stack: ['Python', 'LLMs', 'CTGAN', 'Machine Learning'],
      },
      {
        name: 'Computer Vision für Laserschneidmaschinen',
        description:
          'Entwicklung von Computer-Vision-Algorithmen zur bildbasierten Erkennung und Optimierung von Laserschneidmaschinen-Parametern bei TRUMPF. Verbesserung der Produktionsqualität durch automatisierte Parameteranpassung.',
        stack: ['Python', 'Computer Vision', 'Deep Learning', 'Industrial IoT'],
      },
      {
        name: 'ML-basierte Energieoptimierung',
        description:
          'Anwendung von Machine Learning zur Optimierung energiesparender Shutdown-Prozesse bei Werkzeugmaschinen. Beitrag zur nachhaltigen Produktentwicklung durch intelligente Energieverwaltung in der Halbleiterfertigung.',
        stack: ['Python', 'Machine Learning', 'Azure ML', 'Sustainable Tech'],
      },
      {
        name: 'Smart Factory Consulting',
        description:
          'Beratung von Kunden bei der Planung hochautomatisierter Produktionsumgebungen. Mitarbeit an R&D-Projekten für die nächste Generation von Lasermaschinen in der Halbleiterfertigung.',
        stack: ['Industrial IoT', 'Smart Factory', 'Consulting', 'Project Management'],
      },
    ],
    skills: [
      'Python',
      'R',
      'SQL',
      'JavaScript',
      'Machine Learning',
      'Deep Learning',
      'Computer Vision',
      'NLP',
      'TensorFlow',
      'PyTorch',
      'Apache Spark',
      'Azure ML',
      'Docker',
      'React.js',
      'Power BI',
      'Pandas',
      'SCRUM',
      'ServiceNow',
    ],
    contact: {
      email: 'Karaca.Mehmet@outlook.de',
    },
  },
  en: {
    header: {
      homepage: 'https://karaca.ovh',
      title: 'MK.',
    },
    about: {
      name: 'Mehmet Karaca',
      role: 'Data Scientist & AI Specialist',
      description: `Master's student in Data Science with hands-on experience in Business Informatics and AI. I develop intelligent solutions at the intersection of Machine Learning, Computer Vision, and Smart Factory – from semiconductor manufacturing to sustainable product development. Currently studying at NOVA IMS in Lisbon, combining industry experience with cutting-edge research.`,
      resume: '/Karaca_Mehmet_CV_1.pdf',
      social: {
        linkedin: 'https://linkedin.com/in/karaca-mehmet',
        github: 'https://github.com/mehmet1700',
      },
    },
    projects: [
      {
        name: 'Synthetic Market Research Data with LLMs',
        description:
          'Developed a two-LLM architecture to generate diverse customer personas and their preferences. Trained a CTGAN model on synthetic data to produce realistic market research datasets. Presented at the EU4Dual Conference in Spain/France.',
        stack: ['Python', 'LLMs', 'CTGAN', 'Machine Learning'],
      },
      {
        name: 'Computer Vision for Laser Cutting Machines',
        description:
          'Developed computer vision algorithms for image-based detection and optimization of laser cutting machine parameters at TRUMPF. Improved production quality through automated parameter adjustment.',
        stack: ['Python', 'Computer Vision', 'Deep Learning', 'Industrial IoT'],
      },
      {
        name: 'ML-based Energy Optimization',
        description:
          'Applied machine learning to optimize power-saving shutdown processes in machine tools. Contributed to sustainable product development through intelligent energy management in semiconductor manufacturing.',
        stack: ['Python', 'Machine Learning', 'Azure ML', 'Sustainable Tech'],
      },
      {
        name: 'Smart Factory Consulting',
        description:
          'Advised clients on planning highly automated production environments. Contributed to R&D projects for next-generation laser machines in semiconductor manufacturing.',
        stack: ['Industrial IoT', 'Smart Factory', 'Consulting', 'Project Management'],
      },
    ],
    skills: [
      'Python',
      'R',
      'SQL',
      'JavaScript',
      'Machine Learning',
      'Deep Learning',
      'Computer Vision',
      'NLP',
      'TensorFlow',
      'PyTorch',
      'Apache Spark',
      'Azure ML',
      'Docker',
      'React.js',
      'Power BI',
      'Pandas',
      'SCRUM',
      'ServiceNow',
    ],
    contact: {
      email: 'Karaca.Mehmet@outlook.de',
    },
  },
};

export default content;
